import { useMutation } from '@tanstack/react-query';
import { POST } from '../../../../services';
import { openAlert } from '../../../../components/alert/useAlert';

const POST_UPDATE_PROCESS_STATUS = '/warranty/abm/api/v2/admin/claims/update/process';

export const useProcessStatus = ({ onSuccessCallBack }) => {
  return useMutation({
    mutationFn: async ({ claimId, processStatus }) => {
      const payload = {
        claimId,
        processStatus,
      };
      const response = await POST(POST_UPDATE_PROCESS_STATUS, payload);
      if (onSuccessCallBack) onSuccessCallBack(response);

      return response.result;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'เปลี่ยนสถานะภายในสำเร็จ',
      });
    },
  });
};
